/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
import { CkeditorDragDropService } from '../services/ckeditor-drag-drop.service.js';

export default {
  dynamicEditorConfig: {
    toolbarGroups: [
      { "name": "clipboard", "groups": ["undo"] },
      { "name": "editing", "groups": ["find", "selection", "spellchecker"] },
      { "name": "links" }, 
      { "name": "insert" }, 
      { "name": "forms" }, 
      { "name": "tools" },
      { "name": "document", "groups": ["mode", "document", "doctools"] }, 
      { "name": "others" },
      { "name": "basicstyles", "groups": ["basicstyles", "cleanup"] },
      { "name": "paragraph", "groups": ["list", "indent", "blocks", "align", "bidi"] },
      { "name": "styles" }, 
      { "name": "colors" }, 
      { "name": "about" }
    ],
    autoParagraph: false,
    startupOutlineBlocks: true,
    disableAutoInline: true,
    image: { previewText: ' ' },
    // Prefer <em> for italic; do not list overrides:'i' (basicstyles still hardcodes i→em — cleared on instanceReady)
    coreStyles_italic: { element: 'em' },
    removeButtons: 'About,Anchor,BidiLtr,BidiRtl,Blockquote,Button,Checkbox,Copy,CopyFormatting,CreatePlaceholder,Cut,ExportPdf,Find,Flash,Form,HiddenField,ImageButton,Language,Maximize,NewPage,Paste,PasteFromWord,PasteText,Print,Radio,RemoveFormat,Replace,Save,Scayt,Search,Select,SelectAll,ShowBlocksg,Smiley,SpecialChar,Strike,Styles,Subscript,Superscript,Templates,Textarea,TextField',
    extraPlugins: 'dynamictemplate,find,selectall,divarea,tableresize',
    removePlugins: 'magicline,exportpdf',
    iframe_attributes: (iframe) => {
      const src = iframe.attributes.src || '';
      if (src.startsWith('https://www.youtube.com/') || src.startsWith('https://www.youtube-nocookie.com/') || src.startsWith('https://player.vimeo.com/'))
        return { sandbox: 'allow-scripts allow-same-origin', allow: 'autoplay' };
      return { sandbox: '' };
    }
  },
  configEditor: (CKEDITOR, component) => {
    const pluginName = 'dynamictemplate';
    const tokenWidgetName = 'tokenwidget';
    const reportWidgetName = 'reportwidget';
    window["FE_COMPONENT"] = component;

    CKEDITOR.on( 'dialogDefinition', (evt) => {
      let dialogName = evt.data.name;
      let dialogDefinition = evt.data.definition;
      if ( dialogName == 'table' ) {
        let infoTab = dialogDefinition.getContents( 'info' );
        let txtWidth = infoTab.get( 'txtWidth' );
        txtWidth['default'] = '100%';
      }
    });

    !CKEDITOR.plugins.registered[pluginName] && CKEDITOR.plugins.add(pluginName, {
      requires: 'widget',
      hidpi: true,
      onLoad: function () {
        CKEDITOR.addCss(`
          .fe-report-body {
            background-color: #ff00001f;
          }
          tr.fe-report-body .cke_widget_drag_handler_container {
            display: none !important;
          }
          span.fe-token { 
            background-color: #ffff90b3; 
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-align: inherit;
          }
          div.fe-report {
            border: #ffff90 2px dotted; 
          }
          span.fe-sel-reference { 
            background-color: #ff76006b !important;
            border: #ff76006b 2px dotted !important;
          }
          div.fe-sel-reference { 
            border: #ff76006b 2px dotted !important;
          }
        `);
      },
      init: function (editor) {

        editor.ui.addButton('BlockSplitter', {
          label: 'Insert Blocks',
          command: 'SplitBlock',
          toolbar: 'about'
        });
        editor.addCommand('SplitBlock', { exec: (e) => {  window["FE_COMPONENT"].splitBlock() } });

        editor.ui.addButton('BlockStyles', {
          label: 'Set block selection styles',
          command: 'SetBlockStyles',
          toolbar: 'about'
        });
        editor.addCommand('SetBlockStyles', { exec: (e) => {  window["FE_COMPONENT"].setBlockStyles() } });

        editor.ui.addButton('PageStyles', {
          label: 'Set Page Styles',
          command: 'SetPageStyles',
          toolbar: 'about'
        });
        editor.addCommand('SetPageStyles', { exec: (e) => {  window["FE_COMPONENT"].setBlockStyles(true) } });

        editor.ui.addButton('FieldSenseOn', {
          label: 'Deactivate Field Sense',
          command: 'fieldSenseOff',
          toolbar: 'about'
        });
        editor.addCommand('fieldSenseOff', { exec: (e) => {  window["FE_COMPONENT"].toggleFieldSense(false) } });
        
        editor.ui.addButton('FieldSenseOff', {
          label: 'Activate Field Sense',
          command: 'fieldSenseOn',
          toolbar: 'about'
        });
        editor.addCommand('fieldSenseOn', { exec: (e) => {  window["FE_COMPONENT"].toggleFieldSense(true) } });


        if (editor.contextMenu) {

          // Custom action context  menu
          const custBtnsGroup = 'customActionButtons';
          editor.addMenuGroup(custBtnsGroup);
          let customBtnItems = {};
          const buttonActions = window["FE_COMPONENT"].fe.buttonActions;
          Object.keys(buttonActions).forEach((key) => {
            const { customLabel, name } = buttonActions[key];
            const cmdName = `add${key}BtnCmd`;
            editor.addCommand(cmdName, {
              exec: _editor => window["FE_COMPONENT"].addCustomButton(key)
            });
            const btnActionName = `customActionBtn${name}`;
            customBtnItems[btnActionName] = { label: customLabel, group: custBtnsGroup, command: cmdName };
          });

          editor.addCommand('toggleEditorHorizontalOverflowCmd', {
            exec: () => {
              editor._feHorizontalOverflowOn = !editor._feHorizontalOverflowOn;
              $('dynamic-builder .cke_wysiwyg_div').each(function applyOverflowX() {
                if (editor._feHorizontalOverflowOn) {
                  this.style.setProperty('overflow-x', 'visible', 'important');
                } else {
                  this.style.setProperty('overflow-x', 'hidden', 'important');
                }
              });
            }
          });

          editor.addMenuItems({
            customActionBtns: {
              label: 'Add Form button',
              group: custBtnsGroup,
              getItems: () => customBtnItems
            },
            ...customBtnItems,
            toggleEditorHorizontalOverflow: {
              label: 'Toggle editor horizontal overflow',
              command: 'toggleEditorHorizontalOverflowCmd',
              group: custBtnsGroup
            }
          });
          editor.contextMenu.addListener(_ => ({
            customActionBtns: CKEDITOR.TRISTATE_OFF,
            toggleEditorHorizontalOverflow: CKEDITOR.TRISTATE_OFF
          }));

          // Report actions context menu
          const repBtnsGroup = 'reportButtons';
          editor.addMenuGroup(repBtnsGroup);
          const reportBtnItems = {};
          const repActions = { 
            'Download': { label: 'Download report' },
            'Insert': { label: 'Insert record' },
            'Remove': { label: 'Remove record' } };
          Object.keys(repActions).forEach((action) => {
            const cmdName = `rep${action}Cmd`;
            editor.addCommand(cmdName, {
              exec: _editor => window["FE_COMPONENT"].addReportButton(action, this.reportElemId)
            });
            const btnActionName = `reportBtn${action}`;
            reportBtnItems[btnActionName] = { ...repActions[action], group: repBtnsGroup, command: cmdName };
          });
          editor.addMenuItems({
            reportBtns: {
              label: 'Add Report button',
              group: repBtnsGroup,
              getItems: () => reportBtnItems
            },
            ...reportBtnItems
          });
          editor.contextMenu.addListener(element => {
            const reportElem = element.$.closest('div.fe-report');
            this.reportElemId = null;
            let repBtnFlag;
            if (reportElem) {
              this.reportElemId = $(reportElem).attr("data-token-id");
              repBtnFlag = CKEDITOR.TRISTATE_OFF;
            }
            return { ...repBtnFlag && { reportBtns: repBtnFlag }};
          });
        }

        editor.on('doubleclick', function(evt) {

          let component = window["FE_COMPONENT"];
          const widgetData = evt.data.element.$.attributes?.['data-cke-widget-data']?.value;

          if (widgetData) {
            const selToken = JSON.parse(decodeURIComponent(widgetData));
            if (selToken?.id) {
              component.openTokenModal(selToken.id, selToken.fieldId);
              return;
            }
          }

          const reportContainer = evt.data.element.$.closest('div.fe-report');
          if (reportContainer) {
            const rId = $(reportContainer).attr('data-token-id');
            component.openTokenModal(rId);
            return;
          }
        });

        // Token widget
        editor.widgets.add(tokenWidgetName, {
          dialog: null,
          downcast: function (e) {
            // HTML added to content
            return e;
          },
          init: function () {

            let component = window["FE_COMPONENT"];
            let $element = $(this.element.$);
            const tokenId = this.element.$.dataset.tokenId;
            const fieldId = this.element.$.dataset.fieldId;

            this.setData('id', tokenId);
            fieldId && this.setData('fieldId', fieldId);

            const label = component.getTokenLabel(tokenId, fieldId);
            this.setData('label', label);

            const settings = component.getWrapperAttributes(tokenId, fieldId);
            $(this.wrapper.$).attr(settings.attributes);
            $(this.wrapper.$).addClass(settings.classes.join(' '));

            
            $element.click(() => { 
              component.activateTokenReport(null);
              component.makeTokenResizable(tokenId, fieldId);
            });
          },
          data: function () {
            // Rendered in preview
            const component = window["FE_COMPONENT"];
            this.element.setHtml(component.getRenderedToken(this.data));
            const tokenId = this.data?.id;
            const fieldId = this.data?.fieldId;
            const settings = component.getWrapperAttributes(tokenId, fieldId);
            $(this.wrapper.$).toggleClass('fe-has-behavior', settings.classes.includes('fe-has-behavior'));
          },
        });

        // Report widget
        editor.widgets.add(reportWidgetName, {
          editables: {
            content: {
              selector: '.fe-report',
              allowedContent:
              {
                $1: {
                  elements: CKEDITOR.dtd,
                  attributes: true,
                  styles: true,
                  classes: true
                }
              }
            }
          },
          allowedContent: 'div[data-token-id](!fe-report)',
          requiredContent: 'div[data-token-id](fe-report)',
          upcast: function( element ) {
            return element.name == 'div' && element.hasClass('fe-report');
          },
          init: function() {
            let $element = $(this.element.$);
            let $wrapper = $(this.wrapper.$);

            const tokenId = this.element.$.dataset.tokenId;
            const settings = component.getWrapperAttributes(tokenId);

            $wrapper.attr(settings.attributes);
            $wrapper.addClass(settings.classes.join(' '));
            $element.attr('contenteditable','false');

            $element.click((evt) => { 
              if (!$element[0]) return;
              let component = window["FE_COMPONENT"];
              let $report = component.$activeReportWidget;

              if ($report && $($report).attr('data-token-id') != $($element[0]).attr('data-token-id')) {
                $($report).attr('contenteditable','false');
              }
              $report = $element[0];
              $($report).attr('contenteditable','true');

              const repId = $($report).attr('data-token-id');
              component.$activeReportWidget = $report;
              component.activateTokenReport(repId);
            });
          },
          data: function() {
          }
        } );
      },
      afterInit: function (editor) {
        editor.dataProcessor.dataFilter.addRules({
          elements: {
            span: function(element) {
              if (element.classes?.includes('fe-token') && !element.attributes['data-cke-widget-wrapper']) {
                const tokenId = element.attributes['data-token-id'];
                if (tokenId) {
                  const widgetWrapper = editor.widgets.wrapElement(element, tokenWidgetName);
                  element = widgetWrapper;
                }
              }
            }
          }
        });
      }
    });

    // Preserve empty <i>/<span> (Font Awesome icons, tokens)
    CKEDITOR.dtd.$removeEmpty.span = 0;
    CKEDITOR.dtd.$removeEmpty.i = 0;

    CKEDITOR.replace('dynamicEditor', {
      ...component.EDITOR_CONFIG.dynamicEditorConfig,
      allowedContent: {
        $1: {
          elements: CKEDITOR.dtd,
          attributes: true,
          styles: true,
          classes: true
        }
      }
    });

    let editor = CKEDITOR.instances.dynamicEditor;

    // basicstyles registers contentForms that convert <i> → <em> on getData (source toggle/save).
    // Empty icon <i class="fa ..."> then become empty <em> and are stripped. Drop that transform.
    // See https://github.com/ckeditor/ckeditor4/issues/5075
    let iconIFiltersRegistered = false;
    const preserveIconITags = () => {
      CKEDITOR.dtd.$removeEmpty.i = 0;
      const transformations = editor.filter && editor.filter._ && editor.filter._.transformations;
      if (transformations && transformations.i) delete transformations.i;

      if (iconIFiltersRegistered || !editor.dataProcessor) return;
      iconIFiltersRegistered = true;

      // Keep empty classed <i> from being treated as vacant inline junk on serialize
      const keepEmptyIconI = (el) => {
        if (!el.children.length && (el.attributes.class || el.attributes['class'])) {
          el.add(new CKEDITOR.htmlParser.text('\u200b'));
        }
      };
      editor.dataProcessor.htmlFilter.addRules({ elements: { i: keepEmptyIconI } });
      editor.dataProcessor.dataFilter.addRules({ elements: { i: keepEmptyIconI } });
    };
    preserveIconITags();

    editor.on('change', evt => {
      component.$timeout.cancel(component.debounceContentChange);
      component.debounceContentChange = component.$timeout(_ => {
        if (editor.mode != 'source') {
          component.setTableWidthsPxToIn();
          component.dynamicContent = evt.editor.getData();
          component.updateTemplateObjectsFromContent(true);
          component.setTagEvents();
          component.loadFonts();
        }
      }, 500);
    });

    editor.on('selectionChange', (evt) => {
      if (!editor.modalOpen && editor.bottomActive && editor.pathDepth) {
        component.$timeout(_ => {
          // handle event fired multiple times by ckeditor
          if (editor.modalOpen) return;
          const len = evt.data.path.elements.length;
          const element = evt.data.path.elements[len - editor.pathDepth];
          if (!element || element.$.attributes['data-cke-hidden-sel']) return;
          editor.modalOpen = true;
          component.$timeout(_ => editor.modalOpen = false, 1000);
          if (editor.pathDepth > 1) component.$timeout(_ => component.setHtmlBlockStyles(element.$));
          else component.$timeout(_ => component.setBlockStyles(true));
        });
      }
      component.$timeout(_ => component.deactivateReport(true));
    });
    
    editor.on('elementsPathUpdate', _ => {
      $('.cke_path_item').mouseenter((evt) => { 
        const id = evt.target.id;
        const orig = parseInt(id.split('_').pop());
        const firstId = $('.cke_path').find(':first-child')[0].id;
        const depth =  parseInt(firstId.split('_').pop());
        editor.pathDepth = depth - orig + 1;
      });
      component.$timeout(_ => $('.cke_path_item:first-child').html('page'));
    });
    
    editor.on('mode', function() {
      component.hideTagMenu();
      if (this.mode !== 'source') {
        component.setReferenceTokensStyle();
        component.updateBodyLayout(true);
        component.setTagEvents();
        component.$timeout(() => component.loadFonts(), 400);
      }
    });

    editor.on('instanceReady', _ => {
      // Re-apply after plugins finish registering contentForms (basicstyles italic i→em)
      preserveIconITags();
      // editor.removeMenuItem('cut');	editor.removeMenuItem('copy');	editor.removeMenuItem('paste');
      component.$timeout(() => {
        component.setReferenceTokensStyle(component.selectedReferenceId);
        component.setTagEvents();
      });
    });

    editor.on('beforeCommandExec', evt => {
      const commandName = evt.data.command.name;
      component.removeResizable();
      switch(commandName) {
        case 'source':
          component.removeContentTempStyles();
          break;
        case 'showblocks':
          component.hideTagMenu();
          break;
      }
    });

    editor.on('contentDom', function () {
      // Initialize CKEditor drag & drop service
      new CkeditorDragDropService(editor, component);
      
      // Keep keyup handler for data attributes cleanup
      const editable = editor.editable();
      editable.attachListener(editable, 'keyup', function (evt) {
        if (evt.data.$.keyCode === 13) removeDataAttributes(editor.getSelection().getStartElement());
      });
    });

    editor.on('paste', function (ev) {
      let temp = document.createElement('div');
      temp.innerHTML = ev.data.dataValue;
      let allChildTags = temp.getElementsByTagName('*');
      Array.from(allChildTags).forEach(removeDataAttributes);
      ev.data.dataValue = temp.innerHTML;
      temp.remove();
    });

    function removeDataAttributes(element) {
      element.removeAttribute('data-block-id');
      element.children && Array.from(element.children).forEach(removeDataAttributes);
    }
  }
};